import {Component, inject} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-user-deleted-dialog',
    templateUrl: './user-deleted-dialog.component.html',
    styleUrls: ['./user-deleted-dialog.component.scss'],
    standalone: false
})
export class UserDeletedDialogComponent {
  // Injections
  private readonly dialogRef: MatDialogRef<UserDeletedDialogComponent> = inject(MatDialogRef);

  close(doRestoreUser: boolean = false): void {
    this.dialogRef.close(!!doRestoreUser);
  }

}
